import { kmsClient } from 'api';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import {
  ArticleGroupInterestsQuery,
  ArticleGroupInterestsQueryVariables
} from './__generated__/ArticleGroupInterestsQuery';

export const ARTICLE_GROUP_INTERESTS = gql`
  query ArticleGroupInterestsQuery($id: ID!) {
    articleGroupInterests(id: $id) {
      name
      score
      size
      facebookId
      updatedAt
    }
  }
`;

export const useArticleGroupInterestsQuery = (variables: ArticleGroupInterestsQueryVariables) => {
  return useQuery<ArticleGroupInterestsQuery, ArticleGroupInterestsQueryVariables>(ARTICLE_GROUP_INTERESTS, {
    variables,
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};
